import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/widget-redirect")({
    component: WidgetRedirect,
});

function WidgetRedirect() {
    // Redirect to the widget chat route
    return <Navigate to="/widget/chat" />;
}
